import { ProgressStatCard } from "@/components/ui/progress-stat-card"
import { Star, Trophy, Users } from "lucide-react"

export function ProgressStats() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
      <ProgressStatCard
        icon={<Star className="w-8 h-8 text-amber-600" />}
        label="Points Earned"
        value="1,250"
        iconBgColor="bg-amber-100"
      />
      <ProgressStatCard
        icon={<Trophy className="w-8 h-8 text-teal-600" />}
        label="Class Rank Stats"
        value="#3"
        iconBgColor="bg-teal-100"
      />
      <ProgressStatCard
        icon={<Users className="w-8 h-8 text-rose-600" />}
        label="Total Students"
        value="28"
        iconBgColor="bg-rose-100"
      />
    </div>
  )
}
